/** Короткий список частых IANA-таймзон для <datalist> у полей fromTz/toTz. */
export const COMMON_TIMEZONES: readonly string[] = [
  'UTC',
  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Rome',
  'Europe/Warsaw',
  'Europe/Athens',
  'Europe/Helsinki',
  'Europe/Kiev',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Asia/Nicosia',
  'Asia/Yerevan',
  'Asia/Tbilisi',
  'Asia/Baku',
  'Asia/Jerusalem',
  'Asia/Dubai',
  'Asia/Almaty',
  'Asia/Tashkent',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Hong_Kong',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Kolkata',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Toronto',
  'America/Sao_Paulo',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Australia/Sydney',
  'Pacific/Auckland',
];
